import { Injectable } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import { BehaviorSubject, filter, Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class PageTitleService {
  readonly pageTitle: Observable<string>;

  private _pageTitle = new BehaviorSubject<string>("");

  constructor(router: Router) {
    this.pageTitle = this._pageTitle.asObservable();

    router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe((event) => {
        // Clear current page title on navigation start
        // iff the URL has changed.
        const path = router.url;
        if (!path.startsWith(event.url)) {
          this.setPageTitle("");
        }
      });
  }

  setPageTitle(title: string) {
    this._pageTitle.next(title);
  }

  getPageTitle(): string {
    return this._pageTitle.getValue();
  }
}
